import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';

import AutoTaskInput from './AutoTaskInput';
import AutoProjectInput from './AutoProjectInput';
import AutoUserInput from './AutoUserInput';
import DeleteModal from './DeleteModal';
import DurationFormatter from '../utils/duration';
import ReturnModal from './ReturnModal';

import floatingTaskActions from '../actions/floatingTaskActionCreators';

import { quotaValidation } from '../constants';
import moment from "moment";

require.ensure([], () => {
  require('./AutoTaskInput.less');
});

class FloatingTaskEditor extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedActionIndex: 0,
      quotaNew: 0,
      quotaMerge: "",
      managerName: this.props.managerName,
      message: "",
      selectedProject: this.props.selectedProject,
      showLogEntries: false,
      text: this.props.task.name,
      taskError: false
    };
  }

  // LIFECYCLE METHODS

  componentWillReceiveProps = (newProps) => {
    if (this.state.selectedActionIndex !== 2 && (newProps.selectedProject !== this.props.selectedProject || (newProps.selectedProject === null && this.props.selectedProject !== null))) {
      if (!this._taskExists(this.state.text, newProps.selectedProject) && this.state.taskError) {
        this.setState({ taskError: false });
      } else if (this._taskExists(this.state.text, newProps.selectedProject) && !this.state.taskError) {
        this.setState({ taskError: true });
      }
    }

    return {
      selectedActionIndex: 0,
      managerName: newProps.managerName ? newProps.managerName : newProps.manager
    };
  };

  // EVENT HANDLERS

  handleActionSelect = (id) => {
    this.setState({
      selectedActionIndex: id,
      projectError: false,
      taskError: false,
    });
  };

  handleCancel = () => {
    this.props.handleCancel();
  };

  handleClick = () => {
    this.props.handleClick(this.props.task);
  };

  handleCloseDeleteModal = () => {
    this.setState({
      showDeleteModal: false
    });
  };

  handleCloseReturnModal = () => {
    this.setState({
      showReturnModal: false
    });
  };

  handleConfirmedDelete = () => {
    this.props.handleDelete();
  };

  handleConfirmedReturn(message) {
    this.props.handleReturn(message);
  }

  handleDelete = () => {
    this.setState({
      showDeleteModal: true
    });
  };

  handleKeyDown = (keyEvent) => {
    if (keyEvent.key === "Tab" && this.state.saveFocused) {
      if (this.state.selectedActionIndex === 1)
        ReactDOM.findDOMNode(this.refs.managerInput.refs.userField).focus();
      else
        ReactDOM.findDOMNode(this.refs.projectInput.refs.projectField).focus();
      keyEvent.preventDefault();
    }
  };

  handleMessageChange = (event) => {
    this.setState({
      message: event.target.value
    });
  };

  handleQuotaNewChange = (event) => {
    this.setState({
      quotaNew: event.target.value
    }, this.validateQuotaNew);
  };

  handleQuotaMergeChange = (event) => {
    this.setState({
      quotaMerge: event.target.value
    }, this.validateQuotaMerge);
  };

  handleSave = () => {
    if (this.state.selectedActionIndex === 1) {
      if (!this.props.selectedUser) return;

      if (this.props.selectedUser.id === this.props.currentUser.id) return;

      let manager = this.props.selectedUser;

      this.props.dispatch(floatingTaskActions.reassign(this.props.task.id, manager, this.state.message));
      setTimeout(() => {
        this.props.handleRefresh
      }, 100);
    } else if (this.state.selectedActionIndex === 2) {
      let project = this.props.selectedProject;

      if (!project) {
        this.setState({ projectError: true });
        return;
      }

      this.validateQuotaMerge();
      if (this.state.quotaError) return;
      let quotaMerge;
      if (this.state.quotaMerge === "") {
        quotaMerge = null;
      } else {
        quotaMerge = this.state.quotaMerge * 60;
      }

      let task = this.props.selectedTask;
      if (!task) {
        this.setState({ taskError: true });
        return;
      }

      this.props.dispatch(floatingTaskActions.mergeExisting(this.props.task.id, task.id, quotaMerge));

    } else if (this.state.selectedActionIndex === 3) {
      let project = this.props.selectedProject;

      if (!project) {
        this.setState({ projectError: true });
        return;
      }

      if (this.state.taskError) return;

      this.validateQuotaNew();
      if (this.state.quotaError) return;
      if (!this.state.text) {
        this.setState({ taskError: true });
        return;
      }

      let task = {
        name: this.state.text,
        projectID: project.id
      };

      this.props.dispatch(floatingTaskActions.mergeNew(this.props.task.id, task, this.state.quotaNew * 60));
    }
    this.handleClick();
  };

  handleSaveBlur = () => {
    this.setState({
      saveFocused: false
    });
  };

  handleSaveFocus = () => {
    this.setState({
      saveFocused: true
    });
  };

  handleToggleShowLogEntries = () => {
    this.setState({
      showLogEntries: !this.state.showLogEntries
    });
  };

  handleNewTaskTextChange = (changeEvent) => {
    if (this._taskExists(changeEvent.target.value, this.props.selectedProject)) {
      if (!this.state.taskError) this.setState({ taskError: true });
    } else {
      if (this.state.taskError) this.setState({ taskError: false });
    }
    this.setState({
      text: changeEvent.target.value,
    });
  };

  // OTHER METHODS

  _taskExists = (name, selectedProject) => {
    if (selectedProject) {
      let tasks = this.props.tasks.filter(task => task.projectID == selectedProject.id);
      let searchElement = name.trim().replace(/\s\s+/g, ' ').toLowerCase();
      for (let i = 0; i < tasks.length; i++) {
        let existingTaskName = tasks[i].name.trim().replace(/\s\s+/g, ' ').toLowerCase();
        if (existingTaskName === searchElement) {
          return true;
        }
      }
      return false;
    }
    return false;
  };

  validateQuotaNew = () => {
    this.setState({ quotaError: !quotaValidation.test(this.state.quotaNew) });
  };

  validateQuotaMerge = () => {
    this.setState({ quotaError: !quotaValidation.test(this.state.quotaMerge) });
  };

  // RENDER METHOD

  render = () => {
    let minutesLogged = parseFloat((this.props.timeSpent % 60).toFixed(0));
    let timeSpent = Math.trunc(this.props.timeSpent / 60);
    let overtimeMinutesLogged = parseFloat((this.props.overtimeSpent % 60).toFixed(0));
    let overtimeSpent = Math.trunc(this.props.overtimeSpent / 60);

    let createdAt = "unknown";
    if (this.props.task.createdAt) {
      let createdAtTokens = this.props.task.createdAt.split("T");
      createdAt = createdAtTokens[1].substring(0, 8) + " on " + createdAtTokens[0];
    }

    let formattedReassignTime;
    if (this.props.task._links.dl_reassigner) {
      let formattedReassignTimeTokens = this.props.task.reassignedAt.split("T");
      formattedReassignTime = formattedReassignTimeTokens[1].substring(0, 8) + " on " + formattedReassignTimeTokens[0];

    }

    let dateFilter = {
      startDate: moment(this.props.logEntryKeys[0]),
      endDate: moment(this.props.logEntryKeys[this.props.logEntryKeys.length - 1])
    };

    return (
      <div className="panel panel-default panel-pmtask" onKeyDown={this.handleKeyDown}>
        {
          this.state.showDeleteModal ?
            <DeleteModal taskName={this.props.task.name} handleClose={this.handleCloseDeleteModal}
              handleConfirm={this.handleConfirmedDelete} /> : null
        }
        {
          this.state.showReturnModal ?
            <ReturnModal taskName={this.props.task.name} handleClose={this.handleCloseReturnModal}
              handleConfirm={this.handleConfirmedReturn} /> : null
        }
        <div className="panel-heading" role="tab" id="headingOne">
          <h4 className="panel-title">
            <a onClick={this.handleClick} style={{ wordWrap: "break-word", "cursor": "pointer" }} data-toggle="collapse"
              data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">
              <span className="md-expand-more" />
              {this.props.task.name}
            </a>
          </h4>
        </div>
        <div id="collapseOne" className="panel-collapse" role="tabpanel" aria-labelledby="headingOne">
          <div className="panel-body">
            <div className="form-group">
              <label htmlFor="task_name" className="col-sm-4 control-label">Created by:</label>
              <div className="col-sm-8">
                <p className="form-control-static">{this.props.task.createdBy} <b>at</b> {createdAt}</p>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="task_name" className="col-sm-4 control-label">Description:</label>
              <div className="col-sm-8">
                <p className="form-control-static" style={{ wordWrap: "break-word" }}>{this.props.task.description}</p>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="task_name" className="col-sm-4 control-label">Hours Logged:</label>
              <div className="col-sm-8">
                <p className="form-control-static">
                  {timeSpent}h {minutesLogged}min {overtimeSpent || overtimeMinutesLogged ? " + " + overtimeSpent + "h " + overtimeMinutesLogged + "min overtime" : null}
                  {
                    this.props.logEntryKeys && this.props.logEntryKeys.length > 0 ?
                      <i onClick={this.handleToggleShowLogEntries} style={{ "cursor": "pointer" }}
                        className="md-info" /> : null
                  }
                </p>
              </div>
            </div>
            {
              this.state.showLogEntries ?
                this.props.logEntryKeys.map((name, key) => {
                  let formattedRegularTime = DurationFormatter.format(this.props.logEntryMap[name].regularTime);
                  let formattedOvertime = DurationFormatter.format(this.props.logEntryMap[name].overtime);
                  let descriptions = this.props.logEntryMap[name].descriptions;
                  return (
                    <div className="row" key={key} id={key}>
                      <div className="form-group">
                        <label htmlFor="task_name" className="col-sm-4 control-label">{name}:</label>
                        <div className="col-sm-8">
                          <p
                            className="form-control-static">{formattedRegularTime} {this.props.logEntryMap[name].overtime ? "(+" + formattedOvertime + " overtime)" : ""}</p>
                        </div>
                      </div>
                      {
                        descriptions.map((description, key) => {
                          return (
                            <div className="form-group" key={key} id={key}>
                              <label className="col-sm-4 control-label" />
                              <div className="col-sm-8">
                                <p className="form-control-static"
                                  style={{ "wordWrap": "break-word", "marginTop": "-20px" }}>{description}</p>
                              </div>
                            </div>
                          );
                        })
                      }
                    </div>
                  );
                })
                : null
            }
            <div className="form-group">
              <label className="col-sm-4 control-label">Project Manager:</label>
              <div className="col-sm-8">
                <p className="form-control-static">{this.props.managerName}</p>
              </div>
            </div>
            <hr />
            {
              this.props.task._links.dl_reassigner ?
                <div>
                  <div className="form-group">
                    <label className="col-sm-4 control-label">Reassigned by:</label>
                    <div className="col-sm-8">
                      <p className="form-control-static">{this.props.task.reassignerName}
                        <b> to</b> {this.props.managerName ? this.props.managerName : (this.props.manager ? this.props.manager : "PMO office")}
                        <b> at</b> {formattedReassignTime}</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 control-label">Description:</label>
                    <div className="col-sm-8">
                      <p className="form-control-static">{this.props.task.reassignMessage}</p>
                    </div>
                  </div>
                  <hr />
                </div> : null
            }
            <div className="form-group">
              <label htmlFor="task_name" className="col-sm-4 control-label">Action:</label>
              <div className="col-sm-8">
                <div className="radio">
                  <label title="Reassign floating task to new project manager with a message.">
                    <input checked={this.state.selectedActionIndex === 1}
                      onChange={this.handleActionSelect.bind(this, 1)} type="radio" />Reassign</label>&nbsp; &nbsp;
                  <label title="Move the hours from floating task to existing task on existing project.">
                    <input checked={this.state.selectedActionIndex === 2}
                      onChange={this.handleActionSelect.bind(this, 2)} type="radio" />Resolve
                    (Merge)</label>&nbsp; &nbsp;
                  <label title="Move the hours from floating task to new task on existing project.">
                    <input checked={this.state.selectedActionIndex === 3}
                      onChange={this.handleActionSelect.bind(this, 3)} type="radio" />Resolve
                    (New)</label>&nbsp; &nbsp;
                </div>
              </div>
            </div>
            {
              this.state.selectedActionIndex === 1 ?
                <div>
                  <div className="form-group">
                    <label htmlFor="task_name" className="col-sm-4 control-label">Project Manager:</label>
                    <div className={"col-sm-8"}>
                      <AutoUserInput
                        disableTab
                        enableClear={true}
                        forcePopup={false}
                        forceInitialPopup={false}
                        keepAfterClick={true}
                        ref="managerInput"
                        text={this.props.managerName}
                        users={this.props.pmUsers}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="task_name" className="col-sm-4 control-label">Message:</label>
                    <div className="col-sm-8">
                      <textarea value={this.state.message} onChange={this.handleMessageChange} className="form-control"
                        rows={2} style={{ width: '100%', resize: 'vertical' }} maxLength="255" />
                    </div>
                  </div>
                </div>
                : null
            }
            {
              this.state.selectedActionIndex === 2 ?
                <div>
                  <div className="form-group">
                    <label htmlFor="task_name" className="col-sm-4 control-label">Project Name:</label>
                    <div className={this.state.projectError ? "col-sm-8 has-error" : "col-sm-8"}>
                      <AutoProjectInput
                        ref="projectInput"
                        enableClear
                        filterByDateRange={dateFilter}
                        hideArchived
                        keepAfterClick
                        placeholder="Select existing project"
                        projects={this.props.projects}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 control-label">Task name:</label>
                    <div className={this.state.taskError ? "col-sm-8 has-error" : "col-sm-8"}>
                      <AutoTaskInput
                        enableClear
                        filterByDateRange={dateFilter}
                        hideClosed
                        forceInitialPopup={false}
                        oneline
                        hideArchived
                        ref="taskInput"
                        placeholder={this.props.tasksLoading ? "Loading tasks..." : "Select existing task"}
                        tasks={this.props.tasks}
                        showProject={false}
                        keepAfterClick
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="task_name" className="col-sm-4 control-label">Quota:</label>
                    <div className={this.state.quotaError ? "col-sm-8 has-error" : "col-sm-8"}>
                      <input type="text" value={this.state.quotaMerge} onChange={this.handleQuotaMergeChange}
                        className="form-control" placeholder="Quota - leave blank for no change" />
                    </div>
                  </div>
                </div>
                : null
            }
            {
              this.state.selectedActionIndex === 3 ?
                <div>
                  <div className="form-group">
                    <label htmlFor="task_name" className="col-sm-4 control-label">Project Name:</label>
                    <div className={this.state.projectError ? "col-sm-8 has-error" : "col-sm-8"}>
                      <AutoProjectInput
                        ref="projectInput"
                        enableClear
                        hideArchived
                        keepAfterClick
                        placeholder="Select existing project"
                        projects={this.props.projects}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-4 control-label">Task name:</label>
                    <div className={this.state.taskError ? "col-sm-8 has-error" : "col-sm-8"}>
                      <input
                        className="form-control"
                        onChange={this.handleNewTaskTextChange}
                        placeholder="New task name"
                        ref="newTaskField"
                        style={{ display: "inline" }}
                        title={this.state.text && this.state.text.length > 50 ? this.state.text : null}
                        type="text"
                        value={this.state.text}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="task_name" className="col-sm-4 control-label">Quota:</label>
                    <div className={this.state.quotaError ? "col-sm-8 has-error" : "col-sm-8"}>
                      <input type="text" value={this.state.quotaNew} onChange={this.handleQuotaNewChange}
                        className="form-control" placeholder="Quota" />
                    </div>
                  </div>
                </div>
                : null
            }

          </div>
          <div className="panel-footer">
            {
              this.props.isPmo ?
                <button onClick={this.props.task.deletable ? this.handleConfirmedDelete : this.handleDelete}
                  type="button" className="btn btn-default btn-discrete" data-dismiss="modal">Delete Task</button>
                :
                null
            }
            &nbsp;&nbsp;
            {
              this.state.selectedActionIndex > 0 ?
                <button onFocus={this.handleSaveFocus} onBlur={this.handleSaveBlur} title="Save changes"
                  onClick={this.handleSave} type="button" className="btn btn-default">Save</button>
                : null
            }
          </div>
        </div>
      </div>
    );
  }
}

FloatingTaskEditor.propTypes = {
  createdAt: PropTypes.object,
  dispatch: PropTypes.func,
  handleCancel: PropTypes.func,
  handleClick: PropTypes.func,
  handleDelete: PropTypes.func,
  handleRefresh: PropTypes.func,
  handleReturn: PropTypes.func,
  id: PropTypes.number,
  logEntryMap: PropTypes.object,
  logEntryKeys: PropTypes.array,
  managerName: PropTypes.string,
  overtimeSpent: PropTypes.number,
  pmUsers: PropTypes.array,
  isPmo: PropTypes.bool,
  projects: PropTypes.array,
  task: PropTypes.object,
  tasks: PropTypes.array,
  timeSpent: PropTypes.number
};

FloatingTaskEditor.defaultProps = {
  valid: true,
  projects: [],
  description: '',
  pmUsers: [],
  logEntries: []
};

const mapStateToProps = (state) => {
  let mapLogEntries = (logEntries) => {
    let logEntryMap = {};
    let logEntryKeys = [];

    if (logEntries) {
      for (let i = 0; i < logEntries.length; i++) {
        let logEntry = logEntries[i];
        if (!logEntryMap[logEntry.date]) {
          logEntryMap[logEntry.date] = {
            regularTime: 0,
            overtime: 0,
            descriptions: [],
          };
          logEntryKeys.push(logEntry.date);
        }
        if (logEntry.overtime) {
          logEntryMap[logEntry.date].overtime += logEntry.duration;
        } else {
          logEntryMap[logEntry.date].regularTime += logEntry.duration;
        }
        if (logEntry.description && logEntry.description.trim() !== '') {
          logEntryMap[logEntry.date].descriptions.push(logEntry.description);
        }
      }

      logEntryKeys.sort();
    }

    return {
      logEntryMap: logEntryMap,
      logEntryKeys: logEntryKeys
    };
  };

  let logEntriesObject = mapLogEntries(state.logEntries.userTasks);

  // TODO logEntryMap i logEntryKeys su uvijek prazni
  return {
    currentUser: state.users.currentUser,
    logEntryMap: logEntriesObject.logEntryMap,
    logEntryKeys: logEntriesObject.logEntryKeys,
    pmUsers: state.users.pms.users,
    selectedUser: state.users.selectedUser,
    selectedProject: state.projects.selectedProject,
    selectedTask: state.tasks.selectedTask,
    tasks: state.tasks.allTasks
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, { withRef: true }
)(FloatingTaskEditor);



/** WEBPACK FOOTER **
 ** ./src/app/components/FloatingTaskEditor.js
 **/